module.exports = __webpack_public_path__ + "img/180.3ef51a12.jpg";